export default "__VITE_ASSET__B3NNN$u$__"